import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import MaintenanceBanner from './MaintenanceBanner';

const siteMiantenanceItems = [
  { Icon: AnnouncementOutlinedIcon, label: 'MAINTENANCE BANNER', component: MaintenanceBanner },
  // { Icon: PhotoSizeSelectActualIcon, label: 'LANDING PAGE' },
];

export { siteMiantenanceItems };
